import React from 'react';
import classNames from 'classnames';
import { Box } from '@material-ui/core';
import { grey } from '@material-ui/core/colors';
import Typography from '@material-ui/core/Typography';
import AddLocationIcon from '@material-ui/icons/AddLocation';
import CloudIcon from '@material-ui/icons/Cloud';
import CloudOffIcon from '@material-ui/icons/CloudOff';

// const locale = globals.getArea('dailyPlanning');

const cardItemRender = (item, activeClinician, setActiveClinician, isMileageCapEnabled, hasNoTimeSlots) => {
  const clinician = item.clinician;
  const containerClass = classNames('timeline-card map-timeline-card', {
    'active-clinician': clinician.id === activeClinician.id && clinician.postingId === activeClinician.postingId,
    'no-timeslots': hasNoTimeSlots,
  });

  const showExtraInformation = extraCondition => clinician.showExtraInfo && extraCondition;

  const getViewStyles = () => ({
    backgroundColor: `#${clinician.clinicianColor}`,
    width: '10px',
    height: '10px',
    orderRadius: '6px',
  });

  return (
    <div
      key={`${clinician.id}_${clinician.postingId}`}
      className={containerClass}
      role="presentation"
      onClick={() => setActiveClinician({ id: clinician.id, postingId: clinician.postingId })}
    >
      <div className="timeline-cell">
        <Box display="flex" p={0}>
          <Box py={0.5} flexGrow={0}>
            <AddLocationIcon
              className={`rag-avatar rag-status-${clinician.ragStatus.name.toLowerCase()}`}
              fontSize="small"
            />
          </Box>
          <Box p={0.5} width="140px" flexGrow={1} display="flex" flexDirection="column">
            <Box>
              <Typography className="ellipsis clinician-name" variant="h5">
                {clinician.personName}
              </Typography>
            </Box>
            <Box mb={0.5}>
              <Typography className="ellipsis clinicianCard-subtitle" variant="subtitle1">
                {clinician.band}
              </Typography>
            </Box>
          </Box>
        </Box>
        <Box display="flex" px={0.5} alignItems="center">
          <Box flexGrow={1} display="flex" alignItems="center">
            {showExtraInformation(clinician.desc !== '') && (
              <Typography variant="caption" style={{ color: clinician.descColor }}>
                <span className="icon-extend icon-clock-in-out icon-small" />
                <span className="clinician-description">{clinician.desc}</span>
              </Typography>
            )}
            <span className="icon-extend icon-location icon-small clinician-location-icon">
              <Typography variant="subtitle1" className="ellipsis clinician-locationName">
                {clinician.clinicianLocation ? (
                  clinician.clinicianLocation.postCode
                ) : (
                  <span className="icon-crossed icon-crossed-svg asw-icon" />
                )}
              </Typography>
            </span>
          </Box>
          <Box display="flex" alignItems="center" flexGrow={0} px={0.5}>
            <Box px={0.5}>
              {showExtraInformation(clinician.isOnline) && <CloudIcon fontSize="small" style={{ color: grey[500] }} />}
            </Box>
            <Box px={0.5}>
              {showExtraInformation(!clinician.isOnline) && (
                <CloudOffIcon fontSize="small" style={{ color: grey[500] }} />
              )}
            </Box>
            <Box pr={0.5}>
              {' '}
              {isMileageCapEnabled && clinician.hasValidBasePostCode && clinician.hasMileageCap && (
                <span className="icon-extend icon-radius icon-small p-x-4 milage-cap-icon" />
              )}
            </Box>

            <Box pb={0.5}>
              <div style={getViewStyles()} />
            </Box>
          </Box>
        </Box>
      </div>
    </div>
  );
};

export function CardItemsColumnHtml({
  items,
  activeClinician,
  setActiveClinician,
  isMileageCapEnabled,
  hasNoTimeSlots,
}) {
  return (
    <div className="tbody">
      {items.map(item =>
        cardItemRender(item, activeClinician, setActiveClinician, isMileageCapEnabled, hasNoTimeSlots),
      )}
    </div>
  );
}
